import { withDevtools } from '@ngrx-toolkit/core';
import {
  EmailEntryType,
  EntryType,
  OutlookAbEntryDetails,
  OutlookLeadSearch,
} from '@maximizer/outlook/shared/domain';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type EntryState = {
  entry: OutlookAbEntryDetails | OutlookLeadSearch | null;
  type: EmailEntryType;
};

const initialState: EntryState = {
  entry: null,
  type: EntryType.AbEntry,
};

export const EntryStore = signalStore(
  withDevtools('entry'),
  withState({
    ...initialState,
  }),
  withMethods((store) => ({
    setEntry(entry: OutlookAbEntryDetails | OutlookLeadSearch) {
      patchState(store, () => ({ entry }));
    },
    setType(type: EmailEntryType) {
      patchState(store, () => ({ type }));
    },
  })),
);

export type EntryStore = InstanceType<typeof EntryStore>;
